import React, { memo, useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { Margin, Anchor, Hr } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import { NoCommentsStyled } from './Styled';

const NoneComments = () => {
  const { config } = useContext(context);
  const { productId } = config;
  const href = `/avaliacao/${productId}`;

  return (
    <NoCommentsStyled>
      <div>
        <Margin top={5} bottom={5} />
        <p>Este produto ainda não tem comentários.</p>
        <b>Faça o primeiro :)</b>
      </div>
      <div>
        <Margin top={5} />
        <Hr />
        <Anchor href={href} fullWidth>
          avaliar produto
        </Anchor>
      </div>
    </NoCommentsStyled>
  );
};

const NoComments = memo(NoneComments);

export default NoComments;
export { NoComments };
